import React, { createContext, useContext } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

// Load Stripe with publishable key from environment variables
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const StripeContext = createContext();

export const useStripe = () => {
  const context = useContext(StripeContext);
  if (!context) {
    throw new Error('useStripe must be used within a StripeProvider');
  }
  return context;
};

export const StripeProvider = ({ children }) => {
  const stripeConfig = {
    publishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
    appearance: {
      theme: 'stripe',
      variables: {
        colorPrimary: '#ef4444',
        colorBackground: '#ffffff',
        colorText: '#1e293b',
        colorDanger: '#ef4444',
        borderRadius: '12px',
      },
    },
  };

  return (
    <StripeContext.Provider value={stripeConfig}>
      <Elements stripe={stripePromise} options={{ appearance: stripeConfig.appearance }}>
        {children}
      </Elements>
    </StripeContext.Provider>
  );
};